import {LoginPayload} from './AuthProviderReducer';
import React from 'react';
import { ServicesUrl } from '../../Config/UrlRuotes';

export interface LoginDispacher{
    type?:'REQUEST_LOGIN' | 'LOGIN_SUCCESS' | 'LOGIN_ERROR' | 'LOGOUT' | 'LOGOUT_SUCCESS' | 'CHANGE_USER',
    payload?: LoginPayload
    error?:string
}

export interface LoginPayloadRequest {
    company: string,
    username: string,
    password: string,
}

export interface ActionResponse {
    status: 'ERROR'|'SUCCESS',
    error: {
        'has-error':boolean,
        error?:string
    },
    response: unknown
}

export interface LoginActionResponse extends ActionResponse{
    response: LoginPayload
}

export interface UserApp {
    id: number,
    ids: number,
    clave: string,
    first_name: string,
    last_name: string,
    full_name: string,
    email: string,
    mail_validado: boolean,
    rol: string,
    telephone?: string,
    is_admin: boolean,
    imagen?: string,
}

function processLoginUser(data:LoginActionResponse, dispatch:React.Dispatch<LoginDispacher>){
    const userInfo = data.response;
    console.log('-------> userInfo', userInfo);

    if( data.status === 'ERROR' && data.error['has-error'] ){
        dispatch({ type: 'LOGIN_ERROR', error: data.error.error });
    }

    if (userInfo.token ) {
        dispatch({ type: 'LOGIN_SUCCESS', payload: userInfo });
        localStorage.setItem('currentUser', JSON.stringify(data.response));
    }

    return data;
}

export async function updateLoginUser(data:LoginActionResponse, dispatch:React.Dispatch<LoginDispacher>) {
    return processLoginUser(data, dispatch);
}

export async function loginUser(loginPayload:LoginPayloadRequest, dispatch:React.Dispatch<LoginDispacher>) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginPayload),
    };

    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        const response = await fetch(ServicesUrl.login, requestOptions);

        const data : LoginActionResponse = await response.json();

        return processLoginUser(data, dispatch);
    } catch (err: unknown) {
        console.log(err);
        const message = 'Error al momento de realizar la petición';
        dispatch({ type: 'LOGIN_ERROR', error: message});

        return ;
    }
}

export async function addUserLogin(data:LoginActionResponse, dispatch:React.Dispatch<LoginDispacher>) {
    dispatch({ type: 'REQUEST_LOGIN' });
    return processLoginUser(data, dispatch);
}

export async function logout(dispatch:React.Dispatch<LoginDispacher>) {
    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');

    setTimeout(() => {
        dispatch({ type: 'LOGOUT_SUCCESS' });
    }, 1000);
}

export async function replaceUser(user:UserApp, dispatch:React.Dispatch<LoginDispacher>) {
    const userPayload:LoginPayload = localStorage.getItem('currentUser')
        ? JSON.parse( localStorage.getItem('currentUser') + '' )
        : {};

    if (userPayload.user?.id === user.id){
        console.log('Es el mismisimo usuario', user);
        userPayload.user = user;

        dispatch({ type: 'LOGIN_SUCCESS', payload: userPayload });
        localStorage.setItem('currentUser', JSON.stringify(userPayload));
    }

    return userPayload;
}
